import { Award, Copy } from "lucide-react";
import { toast } from "sonner";

const copyEmail = async (email) => {
  try { await navigator.clipboard.writeText(email); toast.success("Email copied"); } catch { toast.error("Couldn't copy"); }
};

export const TopReferrers = ({ list }) => (
  <div className="rounded-2xl bg-white ring-1 ring-slate-200 p-6" data-testid="admin-top-referrers">
    <div className="flex items-center gap-2 mb-4">
      <Award className="h-5 w-5 text-[#2F7FF0]" />
      <p className="font-display text-lg font-bold text-[#13296B]">Top referrers</p>
    </div>
    {list.length === 0 ? (
      <p className="text-sm text-slate-500 py-6 text-center" data-testid="admin-top-referrers-empty">No referrals yet. Your best recruiters will show up here.</p>
    ) : (
      <ol className="space-y-2">
        {list.map((r, i) => (
          <li key={r.referral_code} className={`flex items-center gap-4 rounded-xl px-4 py-3 ${i === 0 ? "bg-[#13296B] text-white" : "bg-[#F7F9FC]"}`} data-testid={`admin-top-referrer-${i + 1}`}>
            <span className={`font-display text-2xl font-extrabold w-8 ${i === 0 ? "text-[#2F7FF0]" : "text-[#13296B]"}`}>{i + 1}</span>
            <div className="flex-1 min-w-0">
              <p className="font-semibold truncate">{r.name}</p>
              <p className={`text-xs truncate ${i === 0 ? "text-slate-300" : "text-slate-500"}`}>{r.email} · {r.vehicle_type || "—"} · {r.zip} · code {r.referral_code}</p>
            </div>
            <div className="text-right">
              <p className="font-display text-2xl font-extrabold leading-none">{r.referrals}</p>
              <p className={`text-[11px] ${i === 0 ? "text-slate-300" : "text-slate-500"}`}>{r.referrals === 1 ? "driver" : "drivers"}</p>
            </div>
            <button onClick={() => copyEmail(r.email)} aria-label="Copy email" data-testid={`admin-top-referrer-copy-${i + 1}`} className={`p-2 rounded-lg ${i === 0 ? "hover:bg-white/10" : "hover:bg-white"}`}>
              <Copy className="h-4 w-4" />
            </button>
          </li>
        ))}
      </ol>
    )}
  </div>
);
